import { useEffect, useState, useCallback } from "react";
import Prices from "../Prices";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const Login = () => {
  const [_code, setCode] = useState("");
  const [_params, setParams] = useState({});
  const navigate = useNavigate();
  let { site } = useParams();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    let ap = queryParams.get("ap");
    let id = queryParams.get("id");
    let t = queryParams.get("t");
    let url = queryParams.get("url");
    setParams({ ap, id, t, url });
    console.log(ap, id, t, url);
  }, []);

  const submitCode = useCallback(() => {
    // console.log({..._params, code: _code})
    const config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      url: `${window.config.captive_portal_url}/code/${site}`,
      data: { ..._params, code: _code },
    };
    const send = async () => {
      const res = await axios(config);
      console.log(res)
      if (res.status === 200) {
        navigate("/success");
      }
    };
    send();
  }, [_code, _params, navigate, site]);

  return (
    <div className="flex justify-center mx-2 lg:mx-28 mb-10">
      <div className="flex flex-col items-center rounded-md w-auto p-2 md:p-10 bg-gray-100 border-2 border-grey-900">
        <h2 className="text-xl text-bold uppercase">{window.config.name}</h2>
        <div className="mt-5 flex">
          <input
            onChange={(e) => setCode(e.target.value)}
            placeholder="Wprowadź kod"
            name="code"
            className="h-10 w-auto md:mx-5 mx-2 border p-1 md:p-2"
          />
          <button
            className="rounded bg-blue-500 px-2 h-10 w-10 text-white font-bold"
            onClick={submitCode}
          >
            OK
          </button>
        </div>
        <div className="flex flex-col item-center">
          <p className="mt-7 mb-2 text-center">NEOSYSTEM wita serdecznie!</p>
          <div className="md:text-center">
            <p>
              Zapraszamy do skorzystania z internetu moj@wifi. Kody do Internetu
              są do nabycia w recepcji sanatorium.
            </p>
          </div>
          <div>
            <h2 className="uppercase font-bold">Instrukcja:</h2>
            <ul className="ml-4">
              <li>
                1. Sprawdź poziom sygnału w miejscach w których będziesz
                korzystać z Internetu, szczególnie w swoim pokoju.
              </li>
              <li>2. Zakup kod dostępu w recepcji.</li>
              <li>
                3. Wpisz kod aktywacyjny z biletu w polu „Wprowadź kod” i
                zatwierdź przyciskiem "OK".
              </li>
              <li>
                4. Przy użyciu jednego kodu możesz korzystać z różnych urządzeń,
                ale nie w jednym czasie: po zalogowaniu na jedno urządzenie,
                pozostałe urządzenia zostaną wylogowane, utrata biletu lub
                przekazanie go innemu użytkownikowi jest jednoznaczne z utratą
                dostępu do Internetu lub niestabilną pracą połączenia.
              </li>
            </ul>
          </div>

          <div className="flex justify-center mt-8">
            <h2 className="uppercase text-center">
              Dziękujemy za skorzystanie z naszych usług.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
